import React from "react";
import { useAuth } from "./GlobalContext";
import SelectedLink from "./core/views/SelectedLink";
import UpsolverLogo from "./UpsolverLogo";

function HomeSidebarItem() {
  const { currentOrganization } = useAuth();
  const link =
    !currentOrganization ||
    currentOrganization.cloudIntegrations?.length > 0 ||
    currentOrganization.plan.clazz === "FreePlan"
      ? "/home"
      : "/integrations/welcome";
  return (
    <SelectedLink scope={link} to={link} automationName="to-onboard">
      <UpsolverLogo />
    </SelectedLink>
  );
}

export default HomeSidebarItem;
